// extracted by mini-css-extract-plugin
export default {"link":"VEgWJGidKyBzy9Xo32bw"};